module.exports = __webpack_public_path__ + "img/20190819161550QQ截图20190819034111.09a64baf.png";